import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft } from '@fortawesome/free-solid-svg-icons';

export default function InnerLayout({ title, children, right, backHref, bg }: { title: string; children: React.ReactNode; right?: React.ReactNode; backHref?: string; bg?: string }) {
  const navigate = useNavigate();
  return (
    <div className="max-w-md w-[380px] mx-auto min-h-[100vh] bg-[#8b0000]  -mb-[80px]">
      <div className="bg-[#fff]/10 px-4 pt-3 text-black">
        <div className="mx-auto max-w-md">
          <div className="flex items-center">
            <button aria-label="返回" onClick={() => navigate(-1)} className="mr-2 flex h-8 w-8 items-center justify-center rounded bg-white/20">
              <FontAwesomeIcon icon={faAngleLeft} className="h-4 w-4" />
            </button>
            <div className="flex-1 text-center text-xl font-bold">{title}</div>
            {right ?? <div className="h-8 w-8" />}
          </div>
        </div>
      </div>
      {children}
    </div>
  );
}
